/* eslint-disable quotes */
/* eslint-disable semi */
import { storeGetters } from '@store/getters.constants';

const getters = {
//   [storeGetters.getOrgName]: (state) => {
//     return state.organization_name;
//   },
  [storeGetters.getDemoUsers]: (state) => {
    //console.log(state.designations)
    return state.demoUsers;
  },
  [storeGetters.getAgencyUsers]: (state) => {
    //console.log(state.designations)
    return state.agencyUser;
  },
  [storeGetters.putUsers]: (state) => {
    //console.log(state.designations)
    return state.usersList;
  },
//   [storeGetters.getLicenseByid]: (state) => {
//     return state.license;
//   },
//   [storeGetters.getLicenseCount]: (state) => {
//     return state.licenseCount;
//   },
};
export default { ...getters };